import { COLOR_PICKER_TOOL } from '@quicktools/shared-components';

export const BASE_URL = `${process.env.NX_DEPLOY_PATH}${process.env.NX_DEPLOY_SUFFIX}`;
export const VERSION = process.env.NX_APP_VERSION;

export const TOOL_NAME = COLOR_PICKER_TOOL.id;

export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;

export const appText = {
  appName: 'Color Picker',
  seo: {
    title: 'Color Picker Online',
    description:
      'Use the Picsart color picker to generate custom colors and receive relevant RGB, HEX, and HSL codes. Easily export as a PDF, link, or QR code.',
    imageUrl: 'https://cdn140.picsart.com/86124987710707896717.png',
  },
  main: {
    primaryText: 'Color Picker Online',
    secondaryText:
      'Move the slider to find different colors, then click on the gradient to get the color of your choice. Copy and paste anywhere!',
    what: {
      title1: 'What is a color picker?',
      description1_p1:
        'For creative minds who want to design graphics that stand out from the pack, or professionals looking to craft marketing materials that truly catch the eye, finding the perfect color scheme is a subtle but effective technique. That’s where an online color picker is essential.',
      description1_p2:
        'With the Picsart Color Picker tool, you can experiment with endless combinations of gradients, tones, and colors to pick a color perfect for your needs. Create digital media and graphics that are appealing, vibrant, and attention-grabbing in minutes with the Picsart online Color Picker.',

      title2: 'What are HEX, RGB, HSL, and CMYK?',
      description2:
        'A variety of elements go into creating specific colors for graphic design, both for display on screens and for optimal printing. Here are the most important to know:',

      details: [
        {
          title: 'HEX',
          description:
            'Hex color codes are values that tell a display how much of a certain color to show. The values are transmitted via special code that represents color values from 0 to 255. For example, if red, green, and blue are all at the minimum 0 (represented as “00” in the code), the color expressed is the color black. A HEX color picker allows you to adjust this value as needed.',
        },
        {
          title: 'HSL',
          description:
            'HSL refers to hue, saturation, and lightness. Hue refers to a degree on the color wheel from 0 to 360, where 0 is red, 120 is green, and 240 is blue. Saturation is a percentage value, where 0% means a shade of gray and 100% is the full color. Lightness is also a percentage value, where 0% represents black and 100% is white. A HSL color picker allows you to adjust these values to create a custom blend of a specific color.',
        },
        {
          title: 'RGB',
          description:
            'The RGB color system is perhaps the most well-known color system in use worldwide. As an additive color system, RGB combines red, green, and blue light to generate the colors seen on common displays like TV screens, computer monitors, and smartphones. An RGB color picker allows you to specify values of these three primary colors to create a custom blend.',
        },
        {
          title: 'CMYK',
          description:
            'CMYK colors refer to combinations of cyan, magenta, yellow, and black. While displays are primarily oriented to RGB color schemes, printers are calibrated to CMYK colors. This means a CMYK color picker allows you to adjust your color for the best printing performance.',
        },
      ],
    },
  },
  export: {
    option01: 'Copy Link',
    option02: 'Save as PDF',
    option03: 'Get the QR Code',
    copyNotif: 'URL copied to clipboard',
  },
};
